import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


export default function Login({ setToken, token, users, setUsers }) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const navigate = useNavigate();

  async function loginUser(event) {
    event.preventDefault();
    try {
  //     console.log(
  //       "username", username,
  //       "password", password,
  // )
  
  // NEED TO USE EMAIL FROM USERS TABLE FOR LOGIN, USERNAME NOT PRESENT IN OUR TABLES <3
  

      const response = await fetch('http://localhost:4000/api/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          
            email: userName,
            password: password,
          
        })
      });
      let result = await response.json();
      setToken(result.token);
      setShowSuccessMessage(true);
      localStorage.setItem("token", result.token);
      localStorage.setItem("localUser", userName)
      navigate("/profile", { replace: true });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="login"> 
      <form onSubmit={(event) => loginUser(event)}>
      <h1>Login</h1>
        <input
          type="text"
          placeholder="Email"
          value={userName}
          onChange={(event) => setUserName(event.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          />
          <button type="submit">Login</button>
          <div className="signup-message">
          Don't have an account? <Link to="/Register">Sign up</Link>
        </div>
        </form>
        {showSuccessMessage && (
        <div className="success-message">Success: Successfully logged in!</div>
      )}
      </div>
    );
  }